import moment from 'moment-timezone';

/**
 * Returns a two dimensional array of Moment instances representing the weeks
 * and days in the month and year for the provided date.
 * @param date A string, number, date instance, or moment instance used to
 * capture the month and year for which to compute the dates.
 */
export default function getWeekRows(date) {
  var displayDate = moment(date);
  var startDate = displayDate.clone().startOf('month').startOf('week');
  var endDate = displayDate.clone().endOf('month').endOf('week');
  var weeks = [];
  var currentDate = startDate.clone();

  while (currentDate.valueOf() <= endDate.valueOf()) {
    var days = [];

    for (var i = 0; i < 7; i += 1) {
      days.push(currentDate.clone());
      currentDate = currentDate.add(1, 'days');
    }

    weeks.push(days);
  }

  return weeks;
}